import { render, staticRenderFns } from "./SettingsCommunityNodesView.vue?vue&type=template&id=24316d74&"
import script from "./SettingsCommunityNodesView.vue?vue&type=script&lang=ts&"
export * from "./SettingsCommunityNodesView.vue?vue&type=script&lang=ts&"
import style0 from "./SettingsCommunityNodesView.vue?vue&type=style&index=0&id=24316d74&prod&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports